import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { BreadcrumbItemProps } from '@/features/admin/components/AdminPageHeader';
import { ManualXPRoot } from '@/features/manual-xp/components/ManualXPRoot';
import { AppPageContent } from '@/features/shared/components/AppPageContent';
import { AppPageHeader } from '@/features/shared/components/AppPageHeader';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

const manualXPSearchParams = z.object({
  page: fallback(z.number(), 0),
  perPage: fallback(z.number(), 10),
  studentName: fallback(z.string(), ''),
  fromDate: fallback(z.string(), ''),
  toDate: fallback(z.string(), ''),
  subject: fallback(z.string(), ''),
});

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'Home',
    link: { to: '/app' },
  },
  {
    label: 'Administration',
    link: { to: '/app' },
  },
  {
    label: 'Manual XP',
    link: { to: '/app/admin-section/manual-xp' },
  },
];

export const Route = createFileRoute('/_app/app/admin-section/manual-xp')({
  component: RouteComponent,
  validateSearch: zodValidator(manualXPSearchParams),
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR, UserRoles.AIDE]),
  ssr: false,
});

function RouteComponent() {
  return (
    <>
      <AppPageContent>
        <AppPageHeader breadcrumbItems={breadcrumbItems} />
        <ManualXPRoot />
      </AppPageContent>
    </>
  );
}
